import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

type CreateStoreParams = {
    initialData: any;
};
export const createStore = ({ initialData }: CreateStoreParams) => {
    const isProductionEnvironment = process.env.NODE_ENV === 'production';

    const options: ConfigureStoreOptions = {
        devTools: !isProductionEnvironment,
        enhancers: (getDefaultEnhancers) => {
            const enhancers = getDefaultEnhancers();
            if (!isProductionEnvironment) {
                // @ts-expect-error
                const devToolsExtension = window.devToolsExtension;
                if (typeof devToolsExtension === 'function') {
                    return enhancers.concat(devToolsExtension());
                }
            }
            return enhancers;
        },
        middleware: (getDefaultMiddleware) =>
            // It's currently all disabled because our redux is incredibly broken as of now.
            // TODO: tl;dr we want to remove these two flags, as it will add performance gains
            getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
        preloadedState: initialData,
        reducer: rootReducer,
    };
    return { reducer: rootReducer, store: configureStore(options) };
};
